export default __webpack_public_path__ + "static/media/maestro.a8c1eabe.png";